"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeLabelhash = void 0;
function encodeLabelhash(hash) {
    return `[${hash.slice(2)}]`;
}
exports.encodeLabelhash = encodeLabelhash;
//# sourceMappingURL=encodeLabelhash.js.map